export default "__VITE_ASSET__C_BcUXbq__"